import '../css/account.css';
import './index';
import './utils/setMode';
import { getUrlParam} from './utils';
import isDevelopment from './utils/useMode';
import storage from './store';
import { Spinner } from './utils/Spinner';
// const baseURL = API.getBaseURL();
// console.log(baseURL,'base- url');
const baseURL = 'https://zoop.thewatchtower.ae';
const baseAPIURL = 'https://zoop-api.thewatchtower.ae';

const handleAccountType = () => {
    const userType = getUrlParam('user');
    const loginDiv = document.querySelector('.login-div') as HTMLDivElement;
    const restaurantDiv = document.querySelector('.restaurant-div') as HTMLDivElement;
    const deliveryPartnerDiv = document.querySelector('.delivery-partner-div') as HTMLDivElement;
    const title = document.getElementById('title') as HTMLParagraphElement;
    restaurantDiv.classList.remove('active');
    deliveryPartnerDiv.classList.remove('active');
    loginDiv.classList.remove('active');
    title.classList.remove('active');
    if(userType === 'restaurant'){
        restaurantDiv.classList.add('active');
        title.classList.remove('active');

    } else if(userType === 'delivery-partner'){
        deliveryPartnerDiv.classList.add('active');
        title.classList.remove('active');
    }
    else {
        loginDiv.classList.add('active');
        title.classList.add('active');
    }
    
};

function handleGoogleLogin(){
  const restuarantBtn = document.getElementById('restaurant-google-btn');

  restuarantBtn?.addEventListener('click',()=>{
    Spinner.open('Please wait...')
    const isDev = isDevelopment();
    const baseRedirect = isDev ? 'http://localhost:3000/login' : `${baseURL}/login`;
    storage.set('_login_type','restaurant');
    const new_url = `${baseAPIURL}/auth/restaurant/web/google?return_to=${baseRedirect}`;
    // console.log(new_url,'new url')
    window.location.href = new_url;
  });
  const restuarantBtn2 = document.getElementById('restaurant-facebook-btn');
  restuarantBtn2?.addEventListener('click',()=>{
    const isDev = isDevelopment();
    const baseRedirect = isDev ? 'http://localhost:3000/login' : `${baseURL}/login`;
    storage.set('__mode__',isDev ? 'true':'');
    storage.set('_login_type','restaurant');
    const new_url = `${baseAPIURL}/auth/restaurant/web/facebook?return_to=${baseRedirect}`;
    // console.log(new_url,'new url')
    window.location.href = new_url;
  })
}



window.addEventListener('DOMContentLoaded',()=>{
    
    handleAccountType();
    handleGoogleLogin();
})
